import i18n from "i18next";

const getErrorMessage = (code) => {

    const errors = {
        USER_NOT_AUTHENTICATED: i18n.t('USER_NOT_AUTHENTICATED'),
        USER_NOT_FOUND: i18n.t('USER_NOT_FOUND'),
        NOT_EXITS_PHONE_NUMBER: i18n.t('NOT_EXITS_PHONE_NUMBER'),
        USER_CANT_ACCESS_AN_EXAM: i18n.t('USER_CANT_ACCESS_AN_EXAM'),
        NOT_GRANTED: i18n.t('NOT_GRANTED'),
        FAIL_TO_CREATE_TOKEN: i18n.t('FAIL_TO_CREATE_TOKEN'),
        GET_PHONE_NUMBER_BY_UUID_ERROR: i18n.t('GET_PHONE_NUMBER_BY_UUID_ERROR'),
        TEST_NOT_START: i18n.t('TEST_NOT_START'),
        TEST_TIME_OUT: i18n.t('TEST_TIME_OUT'),
        OUT_OF_TRYTIMES: i18n.t('OUT_OF_TRYTIMES'),
        TEST_NOT_EXISTED: i18n.t('TEST_NOT_EXISTED'),
        TESTS_NOT_FOUND: i18n.t('TESTS_NOT_FOUND'),
        TEST_NOT_QUESTIONS: i18n.t('TEST_NOT_QUESTIONS'),
        SOME_THING_IS_WRONG: i18n.t('SOME_THING_IS_WRONG'),
        LESSON_NOT_FOUND: i18n.t('LESSON_NOT_FOUND'),
        LESSON_NOT_STARTED: i18n.t('LESSON_NOT_STARTED'),
        PREVIOUS_LESSON_NOT_COMPLETE: i18n.t('PREVIOUS_LESSON_NOT_COMPLETE'),
        QUESTION_NOT_ENOUGH: i18n.t('QUESTION_NOT_ENOUGH'),
        ANSWERS_SUBMIT_NULL: i18n.t('ANSWERS_SUBMIT_NULL'),
        QUESTION_TYPE_NOT_FOUND: i18n.t('QUESTION_TYPE_NOT_FOUND'),
        TEST_CODE_NOT_FOUND: i18n.t('TEST_CODE_NOT_FOUND'),
        TL_CODE_NULL: i18n.t('TL_CODE_NULL'),
        ANONYMOUS_AUTHENTICATION_TOKEN: i18n.t('ANONYMOUS_AUTHENTICATION_TOKEN'),
        NO_NETWORK: i18n.t('NO_NETWORK'),
    };

    return errors.hasOwnProperty(code) ? errors[code] : code;
};

export default getErrorMessage;